import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Spacer from "../Spacer";
import { getPdxIfuHref } from "../../utils/navigation/ifuLink";
import LangSwitcher from "../LangSwitcher";

export function MenuPanel({
  onClose,
  handleSignOut,
  guidePath,
  showQuestionnaires = true,
  dense = false,
}) {
  const { t, i18n } = useTranslation();
  const lang = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "en-GB"
  ).toLowerCase();
  const ifuHref = getPdxIfuHref(lang);

  const row = dense
    ? "w-full flex flex-row justify-between items-center subtitle-text hover:underline min-h-[40px]"
    : "w-full flex flex-row justify-between items-center subtitle-text hover:underline min-h-[44px]";

  return (
    <div className="flex flex-col gap-1 items-center w-full max-w-lg">
      {/* Close button (optional for desktop; keep for both) */}
      <button
        type="button"
        onClick={onClose}
        aria-label={t("navBar.closeMenu", "Close menu")}
        className="outlined-button self-end mb-2 group"
      >
        <span
          className="material-symbols-outlined text-[24px] text-primary group-hover:text-greyscale-1"
          aria-hidden="true"
        >
          close
        </span>
      </button>

      <div className="w-full flex flex-row justify-between items-center min-h-[44px]">
        <span className="subtitle-text">
          {t("navBar.language", "Language")}
        </span>
        <LangSwitcher showLabelWhenClosed />
      </div>

      <Spacer />

      <button
        type="button"
        onClick={() => {
          onClose();
          handleSignOut();
        }}
        aria-label="Sign out"
        className={row}
      >
        {t("navBar.signOut")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          exit_to_app
        </span>
      </button>

      <Spacer />

      <a
        href={ifuHref}
        target="_blank"
        rel="noopener noreferrer"
        className={row}
        aria-label={t("navBar.ifu", "Instructions For Use")}
        onClick={onClose}
      >
        {t("navBar.ifu", "Instructions For Use")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          open_in_new
        </span>
      </a>

      {/* <Spacer />

      <a
        href="https://www.electronrx.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className={row}
        aria-label={t("navBar.privacy", "Privacy Policy")}
      >
        {t("navBar.privacy", "Privacy Policy")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          open_in_new
        </span>
      </a> */}

      {/* <Spacer />

      <a
        href="https://www.electronrx.com/contact-us"
        target="_blank"
        rel="noopener noreferrer"
        className={row}
        aria-label={t("navBar.contactUs", "Contact Us")}
      >
        {t("navBar.contactUs", "Contact Us")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          open_in_new
        </span>
      </a> */}

      <Spacer />

      <Link to="/guidance" onClick={onClose} className={row}>
        {t("navBar.guidance", "Guidance")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          info
        </span>
      </Link>

      <Spacer />

      <Link to="/about" onClick={onClose} className={row}>
        {t("navBar.about", "About")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          arrow_forward_ios
        </span>
      </Link>

      <Spacer />

      <Link to="/profile" onClick={onClose} className={row}>
        {t("navBar.profile", "Profile")}
        <span
          className="material-symbols-outlined text-[24px]"
          aria-hidden="true"
        >
          arrow_forward_ios
        </span>
      </Link>

      {showQuestionnaires ? (
        <>
          <Spacer />

          <Link to="/questionnaires" onClick={onClose} className={row}>
            {t("navBar.questionnaires", "Questionnaires")}
            <span
              className="material-symbols-outlined text-[24px]"
              aria-hidden="true"
            >
              arrow_forward_ios
            </span>
          </Link>
        </>
      ) : null}

      {guidePath && (
        <>
          <Spacer />
          <Link to={guidePath} onClick={onClose} className={row}>
            {t("navBar.guide", "Guide")}
            <span
              className="material-symbols-outlined text-[24px]"
              aria-hidden="true"
            >
              arrow_forward_ios
            </span>
          </Link>
        </>
      )}
    </div>
  );
}
